import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

/** Static placeholder for list filter rows (search inputs plus facet buttons). */
export const FiltersSkeleton = memo(function FiltersSkeletonComponent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap gap-4"><Skeleton className="h-9 min-w-64 flex-1" /><Skeleton className="h-9 min-w-48 flex-1" /><Skeleton className="h-9 min-w-48 flex-1" /><Skeleton className="h-9 w-28" /><Skeleton className="h-9 w-24" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
});